import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/pages/Login.vue'
import ConfirmationOrder from '../components/pages/ConfirmationOrder.vue'
import DetailsOrder from '../components/pages/DetailsOrder.vue'
import FormPage from '../components/pages/FormPage.vue'
import EditForm from '../components/pages/FormPageEdit.vue'
import Orders from '../components/pages/Orders.vue'

Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    savedPosition.x = 0
    savedPosition.y = 0
    return savedPosition
  } else {
    const position = {}

    if (to.hash) {
      position.selector = to.hash
      if (document.querySelector(to.hash)) {
        return position
      }
      return false
    }
    return { x: 0, y: 0 }
  }
}

const router = new Router({
  mode: 'history',
  scrollBehavior,
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/orden',
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/orden',
      name: 'FormPage',
      component: FormPage
    },
    {
      path: '/confirmacion-orden',
      name: 'ConfirmationOrder',
      component: ConfirmationOrder, 
      props: true,
    },
    {
      path: '/detalles-de-orden',
      name: 'DetailsOrder',
      component: DetailsOrder, 
      props: true,
    },
    {
      path: '/ordenes',
      name: 'Orders',
      component: Orders
    },
    {
      path: '/editar-orden/:orderId',
      name: 'EditOrder',
      component: EditForm, 
      props: { items: true}
    }
  ]
})


router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login']
  
  const authRequired = !publicPages.includes(to.path)
  
  const loggedIn = sessionStorage.getItem('api_token')
  
  
  if (authRequired && !loggedIn) {
    return next('/login')
  }


  next()
})

export default router